import { FC, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';

import { RooftopUpdateDto } from '@libs/dto';
import { useRooftop } from '@carcareers/hooks';
import { RooftopPermissionsInput, RooftopInput } from '@carcareers/components';
import { useForm } from '@carcareers/contexts';

export interface RooftopUpdateFormProps {
  onSuccess?: () => void;
}

export const RooftopUpdateForm: FC<RooftopUpdateFormProps> = ({ onSuccess }) => {
  const navigate = useNavigate();
  const { updateRooftop } = useRooftop();
  const { data, setErrors } = useForm<RooftopUpdateDto>();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    const callbacks = onSuccess ? { onSuccess } : undefined;
    const response = await updateRooftop(data, callbacks);

    if (response?.data) {
      setErrors([]);
    } else if (response?.errors) {
      setErrors(response.errors);
    }
  };

  return (
    <>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
          <RooftopPermissionsInput />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, flex: 1 }}>
          <Typography variant="h5">Rooftop</Typography>
          <RooftopInput type="rooftop" />
        </Box>
      </Box>
      <Box
        sx={(theme) => ({
          display: 'flex',
          gap: theme.spacing(2),
          justifyContent: 'flex-end',
          [theme.breakpoints.down('sm')]: { flexDirection: 'column-reverse' },
          [theme.containerQueries('drawer').down(500)]: { flexDirection: 'column-reverse' },
        })}
      >
        <Button size="large" variant="outlined" color="secondary" onClick={() => navigate(-1)}>
          Cancel
        </Button>
        <Button size="large" variant="contained" color="primary" onClick={handleSubmit}>
          Update Rooftop
        </Button>
      </Box>
    </>
  );
};

export default RooftopUpdateForm;
